import { formatMoney, isCurrencyCode, money } from "@wato/money";
import type { Locale } from "../../api/types";

/**
 * Formats an API amount (minor units as a decimal-integer string + ISO currency) with
 * `@wato/money`: SAR 2 dp, BHD 3 dp, Latin digits in both locales (ADR-0006). No float is
 * ever created on the way — the string goes straight to a bigint.
 */
export function formatAmount(amountMinor: string, currency: string, locale: Locale): string {
  if (!isCurrencyCode(currency)) return amountMinor;
  return formatMoney(money(amountMinor, currency), locale);
}

/** A signed ledger amount: debits shown negative. */
export function formatSigned(
  type: "debit" | "credit",
  amountMinor: string,
  currency: string,
  locale: Locale,
): string {
  return formatAmount(type === "debit" ? `-${amountMinor}` : amountMinor, currency, locale);
}
